// extracted by mini-css-extract-plugin
export default {"inputFormCheckbox":"input-form-checkbox_inputFormCheckbox__zUXE7"};